import { client } from '../client';
import { getStaffScopedApiPrefix } from '../../Utils/staffScopedApiPrefix';
import { Dependent } from './types/Dependent';
import { UserRoleName } from './types/UserProfile';

export type CreateDependentPayload = {
  guardian_relationship: string;
  email?: string | null;
};

export type CreateDependentOptions = {
  /** @deprecated Use userRole. */
  collectorManaged?: boolean;
  userRole?: UserRoleName | string;
};

export const createDependent = async (
  user_id: number,
  payload: CreateDependentPayload,
  options?: CreateDependentOptions,
): Promise<Dependent> => {
  const prefix = options?.collectorManaged
    ? '/collector'
    : getStaffScopedApiPrefix(options?.userRole);
  const path = `${prefix}/users/${user_id}/dependents`;

  const { data } = await client.post<Dependent>(path, payload);

  return data;
};
